module.exports = __webpack_public_path__ + "img/none.d2fc1c71.png";